import api, { transformRequest, transformResponse } from "services/api";

export const packetingRulesApi = api
  .enhanceEndpoints({
    addTagTypes: ["PacketingRules"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchPacketingRules: build.query({
        query: () => "/api/v1/core/debtor-packet-rules/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "PacketingRules", id })),
                { type: "PacketingRules", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'PacketingRules', id: 'LIST' }` is invalidated
              [{ type: "PacketingRules", id: "LIST" }],
      }),
      addPacketingRule: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/debtor-packet-rules/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "PacketingRules", id: "LIST" }],
      }),
      updatePacketingRule: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packet-rules/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "PacketingRules", id: "LIST" }],
      }),
      deletePacketingRule: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packet-rules/${payload.id}/delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "PacketingRules", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchPacketingRulesQuery,
  useAddPacketingRuleMutation,
  useUpdatePacketingRuleMutation,
  useDeletePacketingRuleMutation,
} = packetingRulesApi;
